 const MonthConvert_year = (string) =>{
  const monthMap = {
    '01': 'كانون الثاني',
    '02': 'شباط',
    '03': 'آذار',
    '04': 'نيسان',
    '05': 'أيار',
    '06': 'حزيران',
    '07': 'تموز',
    '08': 'آب',
    '09': 'أيلول',
    '10': 'تشرين الأول',
    '11': 'تشرين الثاني',
    '12': 'كانون الأول'
  };
    var [year,month, day] = string.split('-');
    string =  day+' . '+monthMap[month]+' . '+year
    return string
}
const MonthConvert = (string) =>{
  const monthMap = {
    '01': 'كانون الثاني',
    '02': 'شباط',
    '03': 'آذار',
    '04': 'نيسان',
    '05': 'أيار',
    '06': 'حزيران',
    '07': 'تموز',
    '08': 'آب',
    '09': 'أيلول',
    '10': 'تشرين الأول',
    '11': 'تشرين الثاني',
    '12': 'كانون الأول'
  };
    var [month, day] = string.split('-');
    string =  day+'. '+monthMap[month]
    return string
}
export { MonthConvert,MonthConvert_year}